import React, { useEffect, useState } from "react";
import api from "../utils/api";
import "../styles/private-booking.css";

export default function PrivateBookingSuccess() {
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const offer = query.get("offer");
    const session = query.get("session_id");
    let attempts = 0;
    const check = async () => {
      try {
        const { data } = await api.get(`/api/private-booking/offers/${encodeURIComponent(offer)}/payment-status`, { params: { session_id: session } });
        if (data.status === "paid") return setState({ loading: false, ok: true, data });
        if (++attempts < 10) return window.setTimeout(check, 1500);
        setState({ loading: false, ok: false, message: "Payment is still processing. Check your email shortly." });
      } catch (err) { setState({ loading: false, ok: false, message: err.response?.data?.error || "Unable to confirm payment." }); }
    };
    if (offer && session) check(); else setState({ loading: false, ok: false, message: "Missing payment details." });
  }, []);
  return <main className="private-booking"><section className="private-booking-card success">
    {state.loading ? <><h1>Confirming payment…</h1><p>Please keep this page open.</p></> : state.ok ? <><h1>Payment received</h1><p>Your booking is confirmed.</p><p><strong>Booking ID:</strong> {state.data.booking_id}</p><p>{state.data.offer.pickup} → {state.data.offer.dropoff}</p><b>£{state.data.offer.fare_gbp}</b></> : <><h1>Payment processing</h1><p>{state.message}</p></>}
  </section></main>;
}
